import { Button, Col, Container, Row } from "reactstrap";
import { OurServiceTitle } from "../../../constants";
import { OurServiceContent, ServiceList } from "../../../data/demo/PropertyDemo1";
import { dynamicImage, dynamicSvg, Image } from "../../../utils";
import CommonHeader from "../common/CommonHeader";
import { Play } from "iconsax-react";
import VideoModal from "../../commonComponents/modals/VideoModal";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setVideoModal } from "../../../reduxToolkit/reducers/layoutSlice";

const Services = () => {
  const dispatch = useAppDispatch();
  
  return (
    <section className="section-b-space property-service-section bg-color">
      <Container>
        <Row className="gy-lg-0 gy-4">
          <Col lg="5">
            <div className="service-content">
              <CommonHeader title={OurServiceTitle} content={OurServiceContent} headClass="title-style-1" />
              <ul className="service-list">
                {ServiceList.map((item, index) => (
                  <li key={index}>
                    <div className="service-icon">
                      <Image src={dynamicSvg(item.image)} alt="service-1" className="img-fluid" />
                    </div>
                    <div className="service-info">
                      <h5>{item.title}</h5>
                      <p>{item.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          <Col lg="7">
            <div className="service-img">
              <Image src={dynamicImage("property/service.jpg")} alt="service" className="img-fluid" />
              <div className="service-sub-img">
                <Image src={dynamicImage("other/about/a-2.jpg")} alt="service-sub" className="img-fluid" />
                <Button onClick={() => dispatch(setVideoModal())} className="play-btn">
                  <Play className="iconsax" />
                </Button>
                <VideoModal />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;